const AUTH_URL = import.meta.env.VITE_AUTH_URL as string;

export interface LoginResult {
  access_token: string;
  redirect_url: string;
  user: { id: string; email: string; full_name: string };
}

export async function loginUser(email: string, password: string): Promise<LoginResult> {
  const res = await fetch(`${AUTH_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password, redirect_to: 'HEXA' }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({})) as { detail?: string };
    throw new Error(body.detail ?? 'Credenciales inválidas');
  }

  return res.json() as Promise<LoginResult>;
}
